import { render } from "./SaveOrgUnit.vue?vue&type=template&id=457800ec&scoped=true"
import script from "./SaveOrgUnit.vue?vue&type=script&lang=js"
export * from "./SaveOrgUnit.vue?vue&type=script&lang=js"

import "./SaveOrgUnit.vue?vue&type=style&index=0&id=457800ec&scoped=true&lang=css"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457800ec"]])

export default __exports__